<template>
    <MainLayout>
        <div class="container">
            <div class="box">
                <h2>Cierre de ventas</h2>
                <hr>
                <b-tabs no-fade>
                    <b-tab active lazy>
                        <template #title>
                            Stop Sales <b-badge variant="success" class="ml-1" style="font-size:0.65em">new</b-badge>
                        </template>
                        <StopSalesIndex embedded />
                    </b-tab>
                    <b-tab title="Stop Sales por plan tarifario" lazy>
                        <LockSalesIndex embedded />
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import StopSalesIndex from './Index.vue'
import LockSalesIndex from '../locks-sales/index.vue'

export default {
    components: { MainLayout, StopSalesIndex, LockSalesIndex },
}
</script>
